import {sendDefaultLocation, sendPreferenceData, sendProfileData} from '../../store/slices/me_slice';
import {parseIntOrFallback} from '../../support/parse_int';
import {store as AppStore} from '../../store/store';
import {isRejected} from '@reduxjs/toolkit';
import {CustomerPreferencesInput} from '../../gql/customer/graphql.ts';
import {CustomerPreferences} from '../../support/get_data.ts';

export async function storeProfileData(store: typeof AppStore, token: string, formData: FormData) {
    const defaultLocation = formData.get('default_location');
    const locationId = parseIntOrFallback(defaultLocation, null);
    const customerId = store.getState().customerInfo?.me?.customer?.id;

    if (customerId === null || customerId === undefined) {
        throw new Error('No customer ID found');
    }
    if (locationId !== null) {
        const locationResult = await store.dispatch(sendDefaultLocation({token, locationId: locationId}));
        if (isRejected(locationResult)) {
            throw locationResult.error;
        }
    }
    formData.delete('default_location');

    const preferences = Array.from(formData.entries()).filter(([key]) => key.includes('receive'));
    let preferencesArray: {[index: string]: boolean} = {};
    Object.values(CustomerPreferences).forEach((preference: string) => {
        if (!preference.includes('reminder') && !preference.includes('receive_push_notification_channel')) {
            preferencesArray = {
                ...preferencesArray,
                ...{[preference]: preferences.some((item) => item.some((value) => value === preference))},
            };
        }
    });

    const preferenceData: CustomerPreferencesInput = {
        customer_id: customerId,
        ...preferencesArray,
    };
    const preferenceResult = await store.dispatch(sendPreferenceData({token, preferenceData}));

    if (isRejected(preferenceResult)) {
        throw preferenceResult.error;
    }

    const profileEntries = Array.from(formData.entries()).filter(
        ([key]) => !key.includes('receive') && !key.includes('-disabled'),
    );
    const data = profileEntries.map(([key, value]) => {
        return {
            key,
            value: value.toString(),
        };
    });
    const profileResult = await store.dispatch(sendProfileData({token, data}));
    if (isRejected(profileResult)) {
        throw profileResult.error;
    }
}
